import _ from 'lodash';
import React, { useState } from 'react';

import { Button, Modal } from 'react-bootstrap';

import styles from './confirmation.module.scss';

export const ConfirmationDialog = ({show, title, description, actions = {
  confirm: 'Confirm',
  cancel: 'Cancel'
}, onConfirm, onCancel}) => {
  return (
    <Modal show={show} className={styles.confirmation, styles.dialog} backdropClassName={styles.overlay} centered>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        {description}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onCancel} size="sm" variant="secondary">{_.get(actions, 'cancel') || 'Cancel'}</Button>
        <Button onClick={onConfirm} size="sm" variant="primary">{_.get(actions, 'confirm') || 'Confrim'}</Button>
      </Modal.Footer>
    </Modal>
  );
}